import { put, delay } from 'redux-saga/effects'
import { ConsumerAuthenticationDto } from '../../types/consumerAuthenticationDto'
import {
	authenticateWithApplicantId,
	ReAuthenticateAction,
} from '../actions/authenticateActions'

export function* reAuthenticateSaga(
	action: ReAuthenticateAction,
): Generator<any, void, any | ConsumerAuthenticationDto> {
	const applicantId = action.payload.applicantId
	const token = action.payload.token
	const retry = 3 * 60 * 1000

	const parsedToken = parseJwt(token)
	const expiryDate = new Date(parsedToken.exp * 1000)
	const now = new Date()
	let refreshAfterMs = expiryDate.getTime() - now.getTime() - retry

	if (refreshAfterMs < retry) {
		refreshAfterMs = retry * 5
	}

	yield delay(refreshAfterMs)
	yield put(authenticateWithApplicantId(applicantId))
}

function parseJwt(token: string) {
	const base64Url = token.split('.')[1]!
	const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
	const jsonPayload = decodeURIComponent(
		window
			.atob(base64)
			.split('')
			.map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
			})
			.join(''),
	)

	return JSON.parse(jsonPayload)
}
